module.exports = __webpack_public_path__ + "static/media/buy_request_details_make_2.e55747f9.png";